<template>
  <div>
    <v-card height="45" outlined class="px-2 mt-n1 d-flex justify-start align-center" style="cursor: pointer" @click="$emit('update:filterDialog', true)">
      <div class="d-flex justify-space-between align-center" style="width: 100%">
        <div class="d-flex justify-space-between align-center">
          <v-icon>mdi-tune</v-icon>
          <span class="text_style mx-1" style="letter-spacing: 1px">Filters</span>
        </div>
        <div>
          <v-icon>mdi-menu-down</v-icon>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="filterDialog" max-width="430">
      <v-card class="py-5">
        <v-card-title class="mb-5 d-flex justify-space-between align-center">
          <div class="text-h5"><b> Filters</b></div>
          <div>
            <v-btn text depressed class="pa-0" @click="$emit('cleanFilter')">
              <span class="text_style primary--text" style="letter-spacing: 0px">Clean filters</span>
            </v-btn>
            <v-icon class="ml-3" @click="$emit('update:filterDialog', false)">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="mt-4 mb-3"><b> In-Person or Online</b></div>
          <v-select 
            outlined 
            attach 
            :value="filterTypeModality" 
            :items="filterTypeModalityList" 
            item-text="name" 
            item-value="id" 
            dense 
            hide-details 
            multiple 
            persistent-hint 
            :menu-props="{ maxHeight: '400' }" 
            @input="$emit('update:filterTypeModality', $event)"
          />
          <div class="mt-4 mb-3"><b> Frequency</b></div>
          <v-select 
            outlined 
            attach 
            :value="filterFrequency" 
            :items="filterFrequencyList" 
            dense 
            :menu-props="{ maxHeight: '400' }" 
            hide-details 
            multiple 
            persistent-hint 
            @input="$emit('update:filterFrequency', $event)"
          />
          <div class="mt-4"><b> Date</b></div>
          <v-menu 
            ref="datarangemenu" 
            v-model="datarangemenu" 
            :close-on-content-click="false" 
            :return-value.sync="Renewaldates" 
            transition="scale-transition" 
            offset-y 
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                :value="Renewaldates" 
                append-icon="mdi-calendar" 
                readonly 
                class="my-5" 
                dense 
                hide-details 
                outlined 
                v-bind="attrs" 
                v-on="on" 
              />
            </template>
            <v-date-picker 
              :value="dates" 
              no-title 
              scrollable 
              range 
              @input="$emit('update:dates', $event)"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="datarangemenu = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.datarangemenu.save(Renewaldates)"> OK </v-btn>
            </v-date-picker>
          </v-menu>
          <div class="mt-4 mb-3"><b> Modality</b></div>
          <v-select 
            attach 
            outlined 
            :value="filterModality" 
            :items="filterModalityList" 
            dense 
            :menu-props="{ maxHeight: '300' }" 
            hide-details 
            multiple 
            persistent-hint 
            @input="$emit('update:filterModality', $event)"
          />
          <div class="mt-4 mb-3"><b> Type</b></div>
          <v-select 
            outlined 
            attach 
            :value="filterTypeEvent" 
            :items="filterTypeEventList" 
            :menu-props="{ maxHeight: '400' }" 
            dense 
            hide-details 
            multiple 
            persistent-hint 
            @input="$emit('update:filterTypeEvent', $event)"
          />
          <div class="mt-4 mb-3"><b> Language</b></div>
          <v-select 
            outlined 
            :value="filterLanguage" 
            :items="LanguageList" 
            attach 
            :menu-props="{ maxHeight: '200' }" 
            dense 
            hide-details 
            multiple 
            persistent-hint 
            @input="$emit('update:filterLanguage', $event)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#646464" outlined depressed class="px-5" text @click="$emit('update:filterDialog', false)">
            <span class="text_style"> Cancel </span>
          </v-btn>
          <v-btn color="primary" class="px-8 ml-2" @click="saveFilters" depressed>
            <span class="text_style white--text"> Save Filters </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EventFilters",
  props: {
    filterDialog: Boolean,
    filterTypeModality: Array,
    filterTypeModalityList: Array,
    filterFrequency: Array,
    filterFrequencyList: Array,
    dates: Array,
    filterModality: Array,
    filterModalityList: Array,
    filterTypeEvent: Array,
    filterTypeEventList: Array,
    filterLanguage: Array,
    LanguageList: Array,
  },
  data() {
    return {
      datarangemenu: false,
    };
  },
  computed: {
    Renewaldates: {
      get() {
        return this.dates.join(" to ");
      },
      set(value) {
        this.$emit("update:dates", value.split(" to "));
      },
    },
  },
  methods: {
    saveFilters() {
      this.$emit('update:filterDialog', false);
      this.$emit('saveFilters', {
        filterTypeModality: this.filterTypeModality,
        filterFrequency: this.filterFrequency,
        dates: this.dates,
        filterModality: this.filterModality,
        filterTypeEvent: this.filterTypeEvent,
        filterLanguage: this.filterLanguage,
      });
    },
  },
};
</script>

<style scoped>
.text_style {
  font-family: "DM Sans";
  font-size: 14px;
  text-transform: capitalize;
}
.text-h5 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 700;
}
</style>